import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import LandingPage from './components/LandingPage';
import EmailGate from './components/EmailGate';
import AssessmentFlow from './components/AssessmentFlow';
import ResultsDashboard from './components/ResultsDashboard';
import SharedResult from './components/SharedResult';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/assess" element={<EmailGate />} />
            <Route path="/assess/questions" element={<AssessmentFlow />} />
            <Route path="/results" element={<ResultsDashboard />} />
            <Route path="/results/:resultId" element={<SharedResult />} />
          </Routes>
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;
